export const USER_STATUS = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE'
}

export const isOnline = member => member.status === USER_STATUS.ONLINE;